import { SVGProps, memo } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLogo = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 398.2 63"
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>
        {
          ".st1{fill:var(--color-primary)}.st2{fill:var(--color-secondary)}.st1,.st2{fill-rule:evenodd}"
        }
      </style>
    </defs>
    <path
      d="M108.8 19.8c-7 1.2-10.7 8.1-9.8 16.3.9 7.4 5.8 12.9 14.4 11.4 14.6-2.5 12.7-30.8-4.6-27.7m-1.7-10.1c-12 2.2-21.8 13.4-19.5 28.2 1.9 12.4 12.6 22.3 27.4 20 12-1.9 21.6-13.3 19.5-28-1.8-12.1-13-22.8-27.4-20.2ZM349.9 28.4c.8 1.4 3.3 5.4 4.4 7.1 1.6 2.5 3 4.9 4.6 7.3l6.8 10.6c.6 1 1.7 2.8 2.4 3.6l10.7.2V10.4h-10.2v29.1c-.7-.8-1-1.1-1.5-1.7-1.2-1.9-2.8-4.4-3.9-6.2-1.5-2.3-3-4.6-4.5-7-1.1-1.8-9.5-13.8-10.2-14.4h-9.6V57H349V27.8c.6-.1.7.2 1 .5M277.1 25.4l-4.8 13h10.5l-4.9-13.1h-.8Zm-4.5-15.1-19 46.9h11.5l3.5-9.3h18.1l3.4 9.4h11.4c-.3-1.6-8.5-21.5-9.3-23.5-1.1-2.8-9.2-22.4-9.3-23.6h-10.2ZM59.1 31.2c5.4 0 11.1-.2 11.2-6.1.1-6.2-5.7-6.5-11.2-6.5v12.5Zm-10.8 26H59V39.8c7.8-.1 12.2.5 17.6-3.6 3.6-2.8 6.1-9.3 4.4-15.9-1.4-5.4-5.7-8.8-11.6-9.8-4-.7-16.7-.6-21.1-.3v47ZM28.5 42.1c2.2 4.9-3.7 6.7-7.9 6-2.6-.4-5.9-2.1-8-3.6-.8-.5-1.2-1-2.1-1.4l-5.3 8.8c.5.6.2.4.8.9 2.1 1.8 6.2 3.6 8.8 4.4 7.3 2.2 18 1.5 23-4.7 2.1-2.6 3.6-7.8 2.4-12-1-3.6-4.1-6.4-6.7-8.1-3.3-2.2-6.8-3-10.2-4.9-6.1-3.6-3.4-7.1-.3-7.9 4.5-1.2 8.7 1.4 11.7 2.8.8-.8 4.1-7.3 4.2-8.5-10.1-7-25.1-5.3-28.9 5.2-2.5 7 1 12.1 4.8 15 4.6 3.4 10.8 4.4 13.6 8.3M176.9 44.8c-2.3.4-4.1 2.3-7.9 2.7-17.7 1.9-23.4-19.3-9.2-26.1 6.5-3.1 11.6-1.2 16.7 1.2.9-.9 4.2-7.5 4.5-9-3.3-3.2-10.6-3.6-11-4.1-10.1-.6-15.4 1-22 8-9.6 10.1-8 32.2 9.1 39 7 2.8 19.4 1.7 24-2.8-.7-2.3-4-7.2-4.1-8.9M303.5 18.6c5.3-.2 9.5.7 9.6 6.2-.1 5.9-4.7 6-10.1 6.2v5c0 2.7-.1 2.8 1.1 4 1.5 1.8 2.9 3.9 4.5 5.8.8 1 1.4 1.9 2.2 2.9 1.2 1.5 6.1 8.1 7 8.5h13.1c-1.1-2.1-6.8-8.8-8.8-11.1-1.2-1.3-6.2-7-7.1-8.1 1.3-1.2 10.6-3.4 9.4-15.7-.8-8.1-8-12.2-13-11.9h-8.1l.3 8.2ZM215.9 56.8v-8.7c-4.4 0-10 .1-16.3 0V10.4h-10.3v46.4h26.6"
      className="st1"
    />
    <path
      d="M223.5 57.2h22.9l.2-1.2v-8.1h-23.1v9.3zM223.5 19.5h23.1l-.1-9.3h-22.9l-.1 9.3zM246.3 29h-22.5v9.1h22.5V29z"
      className="st2"
    />
    <path d="M277.1 25.4h.8c0-.7.2-.6-.3-.6l-.4.6Z" className="st1" />
    <path
      d="M392.2 5.1c0 2.2-1.7 3.9-4 3.9s-4-1.7-4-3.9 1.8-3.9 4-3.9 4 1.7 4 3.9Zm-7.1 0c0 1.7 1.3 3.1 3 3.1s3-1.4 3-3.1-1.3-3.1-3-3.1-3 1.4-3 3.1Zm2.4 2h-.9V3.2c.4 0 .9-.1 1.5-.1s1.1.1 1.4.3c.2.2.4.5.4.9s-.3.8-.8.9c.4.2.6.5.7 1 .1.6.2.8.3 1h-1c-.1-.1-.2-.5-.3-.9 0-.4-.3-.6-.8-.6h-.4v1.6Zm.1-2.2h.4c.5 0 .9-.2.9-.6s-.3-.6-.8-.6h-.5v1.1Z"
      style={{
        fill: "var(--color-primary)",
      }}
    />
  </svg>
);
const Logo = memo(SvgLogo);
export default Logo;
